<template>
  <v-container fluid fill-height class="loginOverlay">
    <v-layout flex align-center justify-center>
      <v-flex xs12 md6 lg4 elevation-6>
        <v-toolbar class="tool-bar-app darken-1">
          <v-layout justify-center align-center style="height: 100%;">
            <img class="login--logo" src="@/assets/imagens/logo_mono_cp.png" alt="Logo siged">
          </v-layout>
        </v-toolbar>
        <v-card>
          <v-card-text class="pt-4">
            <v-form @submit.prevent="redefinir" ref="form">
              <v-text-field prepend-icon="email" name="email" v-model="email" required label="Informe seu endereço de e-mail"/>
              <v-alert
                :value="message"
                :type="messageType"
                transition="scale-transition"
              >
                {{message}}
              </v-alert>
              <v-btn :loading="sending" type="submit" class="accent white--text rounded-sm font-weight-regular">
                Solicitar e-mail de redefinição de senha
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import authRepository from '@/repositories/authRepository.js';

export default {
  data(){
    return {
      email: '',
      sending: false,
      message: null,
      messageType: null
    };
  },
  methods: {
    async redefinir(){
      this.sending = true;
      try {
        const response = await authRepository.redefinirSenha(this.email);

            //as mensagens de erro abaixa estão sendo tratadas neste bloco try para exibir mensagem de erro
            //retornadas pela função acima
            if (response.data.errorMessage) {
              this.message = response.data.errorMessage;
              this.messageType = 'error';
            }
            else {
              this.message = response.data.message;
              this.messageType = 'success';
            }

      } catch (error) {
        this.message = error.response.data.errorMessage;
        this.messageType = 'error';
      }
      finally{
        this.sending = false;
      }
    },
  },
  watch: {
    message(){
      if (this.message)
        setTimeout(() => this.message = null, 8000);
    }
  }
}
</script>

<style lang="scss" scoped>
.loginOverlay {
  background-image: url("~@/assets/login-bg.png");
  background-repeat: repeat;
}

.login--logo {
  height: 100%;
}
</style>
